import { useState } from 'react'
import { toast } from 'react-toastify'
import store from 'store'
import { _object } from 'utils/interfaces'

const MediaZip = () => {
  const [zipFile, setZipFile] = useState<File | null>(null)
  const [results, setResults] = useState<_object>({})
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (file && file.name.endsWith('.zip')) {
      setZipFile(file)
    } else {
      setZipFile(null)
      toast.error('Only .zip files are allowed')
    }
  }

  const handleSubmit = async () => {
    if (!zipFile) {
      toast.error('No .zip file selected')
      return
    }

    const formData = new FormData()
    formData.append('entity_type', 'temp-zip-uploads')
    formData.append('file', zipFile)

    const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products-images-upload`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : ''
        },
        body: formData
      })

      const result = await response.json()

      if (result.error === false) {
        setResults(result)
        toast.success(result.message || 'ZIP file uploaded successfully')
      } else {
        toast.error(result.message || 'ZIP upload failed')
      }
    } catch (error) {
      console.error(error)
      toast.error('Upload failed due to a network or server error')
    }
  }

  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Media ZIP Upload</h1>
      </div>

      <div className="flex gap-5 overflow-x-auto rounded-lg bg-white">
        <input
          type="file"
          accept=".zip"
          onChange={handleFileChange}
          className="w-80 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
        />

        <button
          type="button"
          onClick={handleSubmit}
          className="rounded-md bg-purple-900 px-4 py-2 text-sm text-white transition hover:bg-purple-950"
        >
          Upload ZIP File
        </button>
      </div>
      {results?.data?.upload_zip_ref && <p className="mt-3">Reference number </p>}
      <p>{results?.data?.upload_zip_ref}</p>
    </>
  )
}

export default MediaZip
